import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import {ButtonStyles, IconStyles} from "./styles/ToggleButton.css";

class ToggleButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
      active: false,
      styles: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.active !== this.state.active){
      this.setState({active: nextProps.active});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.hovered !== this.state.hovered) {
      let styles = this.getUpdatedStyles();
      this.setState({styles});
    }
    if(prevState.active !== this.state.active) {
      let styles = this.getUpdatedStyles();
      this.setState({styles});
    }
  }

  componentDidMount() {
    let styles = this.getUpdatedStyles();
    this.setState({styles});
  }

  setHover = (hovered) => {
    this.setState({hovered});
  };

  getUpdatedStyles = () => {
    let styleParams = {hovered: this.state.hovered, active: this.state.active, small: this.props.small};
    let styles = ButtonStyles(styleParams);
    if(this.props.additionalStyles) {
      Object.assign(styles, styles, this.props.additionalStyles);
    }
    return styles;
  };

  render() {

    let iconType = this.props.iconType;
    return(
      <button className={"btn"} style={this.state.styles}
              onMouseEnter={() => this.setHover(true)} onMouseLeave={() => this.setHover(false)}
      onClick={this.props.action}>
        <i className="material-icons" style={IconStyles(this.props.small)}>{iconType}</i>
      </button>
    );
  }
}

ToggleButton.propTypes = {
  small: PropTypes.bool,
  active: PropTypes.bool,
  action: PropTypes.func,
  iconType: PropTypes.string,
  additionalStyles: PropTypes.object
};

export default ToggleButton;